/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PreferencesSearch } from '../model';
// @ts-ignore
import { PreferencesSearchRequest } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * UserPreferencesApi - axios parameter creator
 * @export
 */
export const UserPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create/Update the Users search preferences
         * @param {PreferencesSearchRequest} preferencesSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerPreferencesSearchCreate: async (preferencesSearchRequest: PreferencesSearchRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'preferencesSearchRequest' is not null or undefined
            assertParamExists('sellerPreferencesSearchCreate', 'preferencesSearchRequest', preferencesSearchRequest)
            const localVarPath = `/v2/seller/preferences/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preferencesSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the Users search preferences
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerPreferencesSearchRetrieve: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/preferences/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPreferencesApi - functional programming interface
 * @export
 */
export const UserPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create/Update the Users search preferences
         * @param {PreferencesSearchRequest} preferencesSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerPreferencesSearchCreate(preferencesSearchRequest: PreferencesSearchRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreferencesSearch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerPreferencesSearchCreate(preferencesSearchRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the Users search preferences
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerPreferencesSearchRetrieve(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreferencesSearch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerPreferencesSearchRetrieve(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserPreferencesApi - factory interface
 * @export
 */
export const UserPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create/Update the Users search preferences
         * @param {PreferencesSearchRequest} preferencesSearchRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerPreferencesSearchCreate(preferencesSearchRequest: PreferencesSearchRequest, aaSource?: string, options?: any): AxiosPromise<PreferencesSearch> {
            return localVarFp.sellerPreferencesSearchCreate(preferencesSearchRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the Users search preferences
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerPreferencesSearchRetrieve(aaSource?: string, options?: any): AxiosPromise<PreferencesSearch> {
            return localVarFp.sellerPreferencesSearchRetrieve(aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerPreferencesSearchCreate operation in UserPreferencesApi.
 * @export
 * @interface UserPreferencesApiSellerPreferencesSearchCreateRequest
 */
export interface UserPreferencesApiSellerPreferencesSearchCreateRequest {
    /**
     * 
     * @type {PreferencesSearchRequest}
     * @memberof UserPreferencesApiSellerPreferencesSearchCreate
     */
    readonly preferencesSearchRequest: PreferencesSearchRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserPreferencesApiSellerPreferencesSearchCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerPreferencesSearchRetrieve operation in UserPreferencesApi.
 * @export
 * @interface UserPreferencesApiSellerPreferencesSearchRetrieveRequest
 */
export interface UserPreferencesApiSellerPreferencesSearchRetrieveRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof UserPreferencesApiSellerPreferencesSearchRetrieve
     */
    readonly aaSource?: string
}

/**
 * UserPreferencesApi - object-oriented interface
 * @export
 * @class UserPreferencesApi
 * @extends {BaseAPI}
 */
export class UserPreferencesApi extends BaseAPI {
    /**
     * 
     * @summary Create/Update the Users search preferences
     * @param {UserPreferencesApiSellerPreferencesSearchCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferencesApi
     */
    public sellerPreferencesSearchCreate(requestParameters: UserPreferencesApiSellerPreferencesSearchCreateRequest, options?: any) {
        return UserPreferencesApiFp(this.configuration).sellerPreferencesSearchCreate(requestParameters.preferencesSearchRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the Users search preferences
     * @param {UserPreferencesApiSellerPreferencesSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPreferencesApi
     */
    public sellerPreferencesSearchRetrieve(requestParameters: UserPreferencesApiSellerPreferencesSearchRetrieveRequest = {}, options?: any) {
        return UserPreferencesApiFp(this.configuration).sellerPreferencesSearchRetrieve(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
